import { useCallback, useState } from "react";

import { useHistory } from "react-router-dom";

import { saveTokenPair } from "apiCommandsExecutor/token";
import { signUp } from "services/auth/rest";
import { isCompletePhone } from "shared/lib/phoneNumber";
import { useSession } from "shared/hooks/useSession";
import { useNotificationSnackbar } from "shared/ui";

// Минимум повторяет проверку бэка (AccountPasswordUtils): короче — форма не отправится.
const MIN_PASSWORD_LENGTH = 4;

export const useSignUpState = () => {
    const history = useHistory();
    const { account, refresh } = useSession();
    const notify = useNotificationSnackbar();

    const [phone, setPhone] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [passwordConfirmation, setPasswordConfirmation] = useState<string>("");
    const [submitting, setSubmitting] = useState<boolean>(false);

    const isPhoneComplete = isCompletePhone(phone);
    const isPasswordTooShort = password.length > 0 && password.length < MIN_PASSWORD_LENGTH;
    const isConfirmationMismatched =
        passwordConfirmation.length > 0 && password !== passwordConfirmation;

    const canSubmit =
        isPhoneComplete &&
        password.length >= MIN_PASSWORD_LENGTH &&
        password === passwordConfirmation &&
        !submitting;

    // Флаг на успехе не снимаем — экран уезжает на список меню и размонтируется (см. useSignInState).
    const submit = useCallback(async () => {
        if (!canSubmit) return;

        setSubmitting(true);
        try {
            const tokenPair = await signUp({ phoneNumber: phone, password });

            // ⚠️ strictNullChecks выключен — пустой ответ ловим руками, иначе форма молча замрёт.
            if (!tokenPair) throw new Error("Не удалось получить токен авторизации");

            saveTokenPair(tokenPair);

            // refresh() не бросает, а отдаёт null и на сетевой ошибке — проверяем явно.
            if (!(await refresh())) {
                throw new Error("Аккаунт создан, но не удалось загрузить его данные");
            }

            history.push("/menus/regular/list");
        } catch (e) {
            setSubmitting(false);
            notify.showError("Не удалось создать аккаунт", e);
        }
    }, [canSubmit, history, notify, password, phone, refresh]);

    return {
        isAuthorized: !!account,
        phone,
        password,
        passwordConfirmation,
        submitting,
        isPhoneComplete,
        isPasswordTooShort,
        isConfirmationMismatched,
        canSubmit,
        notify,
        setPhone,
        setPassword,
        setPasswordConfirmation,
        submit,
    };
};
